import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { ProductsList } from './components/ProductsList';

import { PAGES } from 'constants/pages';

export const Products = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.products} />
                </HeaderTitle>
                <ButtonsContainer>
                    <Link to="/product/imports">
                        <TotemPrimaryButton $isSecondaryStyle>Imports CSV</TotemPrimaryButton>
                    </Link>
                    <Link to="/product/create">
                        <TotemPrimaryButton data-test="create-product-button">Créer un produit</TotemPrimaryButton>
                    </Link>
                </ButtonsContainer>
            </Header>
            <Content>
                <ListContainer>
                    <ProductsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    padding: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
